/* PULZE CONTROLLERS — shared colour data (single source of truth)

   PULZE_PALETTE  every swatch, mirroring each builder's PAL array EXACTLY, in
   order. The builders apply it positionally and verify the name before
   overwriting the hex, so their index anchors keep working.

   PULZE_ZONES    which meshes make up each colourable zone, that zone's factory
   default colour, and whether the builder PAINTS it by default (paint:false
   keeps the stock texture and is only tinted).

   PULZE_OEM      the Controller Base colourways expanded per zone, plus each
   preset's finish: r = roughness (the builder's 'shine', default .95),
   m = metalness, e = envMapIntensity.

   PULZE_SHELLS   which shell colours are actually orderable per platform, taken
   from each builder's ZONE_PAL. This is what the upgrades page offers for a
   re-shell, so a colour dropped from a builder disappears from the service too.
   Note the builders prepend an OEM swatch at runtime, so these lists are the
   colour choices only — "keep it OEM" is handled separately.

   Node names in PULZE_ZONES are PREFIXES, matched as the builders match them:
   name.toLowerCase().startsWith(node).

   Read by assets/pulze-card-3d.js and the service pages via a key: 'ps5', 'ps4'
   or 'xbox'. The Pro builders (MH5, MH4, XSX) share their base platform's key. */

window.PULZE_PALETTE = {
  ps5: [
    ["White","#f2f4f8"], ["Black","#15171c"], ["Graphite","#4a4f5a"],
    ["Silver","#c8ccd6"], ["Crimson","#c62f28"], ["Sunset","#ff6f2c"],
    ["Gold","#d9a52f"], ["Mint","#3fc9a4"], ["Cyan","#28a8dc"],
    ["Royal","#2f47c9"], ["Violet","#7c5cff"], ["Magenta","#c840c4"],
    ["Rose","#e8618c"], ["Lime","#8ed12f"], ["Copper","#b46a3a"],
    ["Navy","#1b2450"], ["Midnight Black","#1c1d21"], ["Cosmic Red","#c01f4a"],
    ["Starlight Blue","#4aace1"], ["Nova Pink","#f0a3bc"], ["Galactic Purple","#6d25c6"],
    ["Sterling Silver","#b9bcc2"], ["Volcanic Red","#8f2429"], ["Cobalt Blue","#2c4a9e"],
    ["Chroma Indigo","#3f45bb"], ["Indigo Deep","#33276e"], ["Chroma Teal","#246f61"],
    ["Teal Deep","#1c5a5e"], ["Remix Green","#8ede3a"], ["Techno Red","#e5252b"],
    ["Rhythm Blue","#35bdf2"], ["Orange","#e45f31"], ["Vampire","#730a0c"],
    ["Yellow","#f7ba48"], ["Light Blue","#8ccde0"], ["Green","#49c442"],
    ["Mint Green","#87e5b8"], ["Gray","#9da9b3"], ["Red","#c62937"],
    ["White","#f5f7fb"], ["Pink","#eaadc8"], ["Coral","#f8a69b"],
    ["Purple","#563495"], ["Black","#19191b"], ["Blue","#0d53a8"],
    ["Neon Green","#00c93f"], ["Light Purple","#b7c5f2"], ["Matcha Green","#90b186"],
    ["Black","#15171c"], ["White","#e8e4dd"], ["Red","#dc3b2a"],
    ["Blue","#4079c4"], ["Green","#22c46c"], ["Yellow","#ead04e"]
  ],
  ps4: [
    ["White","#f2f4f8"], ["Black","#15171c"], ["Graphite","#4a4f5a"],
    ["Silver","#c8ccd6"], ["Crimson","#c62f28"], ["Sunset","#ff6f2c"],
    ["Gold","#d9a52f"], ["Mint","#3fc9a4"], ["Cyan","#28a8dc"],
    ["Royal","#2f47c9"], ["Violet","#7c5cff"], ["Magenta","#c840c4"],
    ["Rose","#e8618c"], ["Lime","#8ed12f"], ["Copper","#b46a3a"],
    ["Navy","#1b2450"], ["Midnight Black","#1c1d21"], ["Cosmic Red","#c01f4a"],
    ["Starlight Blue","#4aace1"], ["Nova Pink","#f0a3bc"], ["Galactic Purple","#6d25c6"],
    ["Sterling Silver","#b9bcc2"], ["Volcanic Red","#8f2429"], ["Cobalt Blue","#2c4a9e"],
    ["Chroma Indigo","#3f45bb"], ["Indigo Deep","#33276e"], ["Chroma Teal","#246f61"],
    ["Teal Deep","#1c5a5e"], ["Remix Green","#8ede3a"], ["Techno Red","#e5252b"],
    ["Rhythm Blue","#35bdf2"], ["Orange","#e45f31"], ["Vampire","#730a0c"],
    ["Yellow","#f7ba48"], ["Light Blue","#66bdd6"], ["Green","#49c442"],
    ["Mint Green","#87e5b8"], ["Gray","#9da9b3"], ["Red","#c62937"],
    ["White","#f5f7fb"], ["Pink","#eaadc8"], ["Coral","#f8a69b"],
    ["Purple","#563495"], ["Black","#19191b"], ["Blue","#0d53a8"],
    ["Neon Green","#00c93f"], ["Light Purple","#b7c5f2"], ["Matcha Green","#90b186"],
    ["Slate","#313339"]
  ],
  xbox: [
    ["White","#f2f4f8"], ["Black","#15171c"], ["Graphite","#4a4f5a"],
    ["Silver","#c8ccd6"], ["Crimson","#c62f28"], ["Sunset","#ff6f2c"],
    ["Gold","#d9a52f"], ["Mint","#3fc9a4"], ["Cyan","#28a8dc"],
    ["Royal","#2f47c9"], ["Violet","#7c5cff"], ["Magenta","#c840c4"],
    ["Rose","#e8618c"], ["Lime","#8ed12f"], ["Copper","#b46a3a"],
    ["Navy","#1b2450"], ["Midnight Black","#1c1d21"], ["Cosmic Red","#c01f4a"],
    ["Starlight Blue","#4aace1"], ["Nova Pink","#f0a3bc"], ["Galactic Purple","#6d25c6"],
    ["Sterling Silver","#b9bcc2"], ["Volcanic Red","#8f2429"], ["Cobalt Blue","#2c4a9e"],
    ["Chroma Indigo","#3f45bb"], ["Indigo Deep","#33276e"], ["Chroma Teal","#246f61"],
    ["Teal Deep","#1c5a5e"], ["Remix Green","#8ede3a"], ["Techno Red","#e5252b"],
    ["Rhythm Blue","#35bdf2"], ["Orange","#e45f31"], ["Vampire","#730a0c"],
    ["Yellow","#f7ba48"], ["Light Blue","#66bdd6"], ["Green","#49c442"],
    ["Mint Green","#87e5b8"], ["Gray","#9da9b3"], ["Red","#c62937"],
    ["White","#f5f7fb"], ["Pink","#eaadc8"], ["Coral","#f8a69b"],
    ["Purple","#563495"], ["Robot White","#f2f4f8"], ["Carbon Black","#26262a"],
    ["Shock Blue","#1b46c2"], ["Pulse Red","#d92b2b"], ["Electric Volt","#d6f24a"],
    ["Deep Pink","#e0397f"], ["Velocity Green","#4ad55e"], ["Astral Purple","#6b3fa0"],
    ["Black","#19191b"], ["Blue","#0d53a8"], ["Neon Green","#00c93f"],
    ["Light Purple","#b7c5f2"], ["Matcha Green","#90b186"], ["Slate","#313339"]
  ]
};

window.PULZE_SHELLS = {
  ps5: {
    shell_front: ["Orange","Vampire","Yellow","Light Blue","Green","Mint Green","Gray","Red","White"],
    shell_back: ["Pink","Coral","Orange","Vampire","Yellow","Light Blue","Green","Mint Green","Gray","Red","White","Purple"]
  },
  ps4: {
    shell_front: ["Purple","Blue","Orange","Light Blue","Pink"],
    shell_back: ["Light Blue","Pink"]
  },
  xbox: {
    shell_front: ["Purple","Blue","Orange","Light Blue","Pink"],
    shell_back: ["Light Blue","Pink"]
  }
};

window.PULZE_ZONES = {
  ps5: [
    {id:"shell_front",def:"White",nodes:["shell_front_plate"]},
    {id:"shell_back",def:"White",nodes:["shell_back_plate"]},
    {id:"trim",def:"Black",nodes:["black_shell"]},
    {id:"l1",def:"White",nodes:["bumper_left"]},
    {id:"r1",def:"White",nodes:["bumper_right"]},
    {id:"l2",def:"White",nodes:["trigger_left"]},
    {id:"r2",def:"White",nodes:["trigger_right"]},
    {id:"action",def:"White",paint:false,nodes:["action_buttons_outer"]},
    {id:"dpad",def:"White",paint:false,nodes:["d_pad_buttons_outer"]},
    {id:"share",def:"Graphite",nodes:["share_button"]},
    {id:"options",def:"Graphite",nodes:["options_button"]},
    {id:"ps_btn",def:"Graphite",nodes:["ps_button"]},
    {id:"stick_l",def:"Black",nodes:["stick_left"]},
    {id:"stick_r",def:"Black",nodes:["stick_right"]},
    {id:"rings",def:"Black",nodes:["ring_left","ring_right"]},
    {id:"touchpad",def:"White",nodes:["touchpad"]}
  ],
  ps4: [
    {id:"shell_front",def:"Black",nodes:["shell_front_plate"]},
    {id:"shell_back",def:"Black",nodes:["shell_back_plate","back_port_face"]},
    {id:"action",def:"Black",nodes:["action_buttons"]},
    {id:"dpad",def:"Black",nodes:["d_pad"]},
    {id:"share",def:"Black",nodes:["share"]},
    {id:"options",def:"Black",nodes:["options"]},
    {id:"ps_btn",def:"Black",nodes:["ps_button"]},
    {id:"l1",def:"Black",nodes:["bumper_left"]},
    {id:"r1",def:"Black",nodes:["bumper_right"]},
    {id:"l2",def:"Black",nodes:["trigger_left"]},
    {id:"r2",def:"Black",nodes:["trigger_right"]},
    {id:"touchpad",def:"Black",nodes:["touchpad"]},
    {id:"stick_l",def:"Black",nodes:["stick_left"]},
    {id:"stick_r",def:"Black",nodes:["stick_right"]}
  ],
  xbox: [
    {id:"shell_front",def:"Black",nodes:["front_shell"]},
    {id:"shell_back",def:"Black",nodes:["back_shell","battery_lid"]},
    {id:"side_shells",def:"Black",nodes:["side_shells"]},
    {id:"action",def:"Black",paint:false,nodes:["action_button_a","action_button_b","action_button_x","action_button_y"]},
    {id:"dpad",def:"Black",paint:false,nodes:["d_pad"]},
    {id:"view_btn",def:"Black",paint:false,nodes:["view_button","menu_button","share_button"]},
    {id:"bumpers",def:"Black",nodes:["bumpers","top_panel","pair_button"]},
    {id:"triggers",def:"Black",nodes:["triggers"]},
    {id:"stick_l",def:"Black",paint:false,nodes:["left_thumbstick","ps4_stick_l","ps5_stick_l","edge_stick_l"]},
    {id:"stick_r",def:"Black",paint:false,nodes:["right_thumbstick","ps4_stick_r","ps5_stick_r","edge_stick_r"]}
  ]
};

window.PULZE_OEM = {
  ps5: [
    {label:"Glacier White",fin:{r:.95},map:{shell_front:"White",shell_back:"White",l1:"Black",r1:"Black",l2:"Black",r2:"Black",trim:"Black",action:"White",dpad:"White",share:"White",options:"White",ps_btn:"Black",stick_l:"Black",stick_r:"Black",rings:"Black",touchpad:"White"}},
    {label:"Midnight Black",fin:{r:.62},map:{shell_front:"Midnight Black",shell_back:"Midnight Black",l1:"Midnight Black",r1:"Midnight Black",l2:"Midnight Black",r2:"Midnight Black",trim:"Midnight Black",action:"Midnight Black",dpad:"Midnight Black",share:"Midnight Black",options:"Midnight Black",ps_btn:"Midnight Black",stick_l:"Midnight Black",stick_r:"Midnight Black",rings:"Midnight Black",touchpad:"Midnight Black"}},
    {label:"Cosmic Red",fin:{r:.72},map:{shell_front:"Cosmic Red",shell_back:"Cosmic Red",l1:"Black",r1:"Black",l2:"Black",r2:"Black",trim:"Black",action:"Cosmic Red",dpad:"Cosmic Red",share:"Cosmic Red",options:"Cosmic Red",ps_btn:"Black",stick_l:"Black",stick_r:"Black",rings:"Black",touchpad:"Cosmic Red"}},
    {label:"Starlight Blue",fin:{r:.6},map:{shell_front:"Starlight Blue",shell_back:"Starlight Blue",l1:"Black",r1:"Black",l2:"Black",r2:"Black",trim:"Black",action:"Starlight Blue",dpad:"Starlight Blue",share:"Starlight Blue",options:"Starlight Blue",ps_btn:"Black",stick_l:"Black",stick_r:"Black",rings:"Black",touchpad:"Starlight Blue"}},
    {label:"Galactic Purple",fin:{r:.55},map:{shell_front:"Galactic Purple",shell_back:"Galactic Purple",l1:"Black",r1:"Black",l2:"Black",r2:"Black",trim:"Black",action:"Galactic Purple",dpad:"Galactic Purple",share:"Galactic Purple",options:"Galactic Purple",ps_btn:"Black",stick_l:"Black",stick_r:"Black",rings:"Black",touchpad:"Galactic Purple"}},
    {label:"Remix Green",fin:{r:.22,m:.16,e:1.2},map:{shell_front:"Black",shell_back:"Black",l1:"Black",r1:"Black",l2:"Black",r2:"Black",trim:"Remix Green",action:"Black",dpad:"Black",share:"Black",options:"Black",ps_btn:"Remix Green",stick_l:"Remix Green",stick_r:"Remix Green",rings:"Remix Green",touchpad:"Black"}},
    {label:"Techno Red",fin:{r:.22,m:.16,e:1.2},map:{shell_front:"Black",shell_back:"Black",l1:"Black",r1:"Black",l2:"Black",r2:"Black",trim:"Techno Red",action:"Black",dpad:"Black",share:"Black",options:"Black",ps_btn:"Techno Red",stick_l:"Techno Red",stick_r:"Techno Red",rings:"Techno Red",touchpad:"Black"}},
    {label:"Rhythm Blue",fin:{r:.22,m:.16,e:1.2},map:{shell_front:"Black",shell_back:"Black",l1:"Black",r1:"Black",l2:"Black",r2:"Black",trim:"Rhythm Blue",action:"Black",dpad:"Black",share:"Black",options:"Black",ps_btn:"Rhythm Blue",stick_l:"Rhythm Blue",stick_r:"Rhythm Blue",rings:"Rhythm Blue",touchpad:"Black"}},
    {label:"Chroma Indigo",fin:{r:.42,m:.26,e:1.05},map:{shell_front:"Chroma Indigo",shell_back:"Chroma Indigo",l1:"Indigo Deep",r1:"Indigo Deep",l2:"Indigo Deep",r2:"Indigo Deep",trim:"Indigo Deep",action:"Indigo Deep",dpad:"Indigo Deep",share:"Indigo Deep",options:"Indigo Deep",ps_btn:"Indigo Deep",stick_l:"Indigo Deep",stick_r:"Indigo Deep",rings:"Indigo Deep",touchpad:"Chroma Indigo"}},
    {label:"Chroma Teal",fin:{r:.42,m:.26,e:1.05},map:{shell_front:"Chroma Teal",shell_back:"Chroma Teal",l1:"Teal Deep",r1:"Teal Deep",l2:"Teal Deep",r2:"Teal Deep",trim:"Teal Deep",action:"Teal Deep",dpad:"Teal Deep",share:"Teal Deep",options:"Teal Deep",ps_btn:"Teal Deep",stick_l:"Teal Deep",stick_r:"Teal Deep",rings:"Teal Deep",touchpad:"Chroma Teal"}},
    {label:"Chroma Pearl",fin:{r:.24,m:.22,e:1.35},map:{shell_front:"White",shell_back:"White",l1:"White",r1:"White",l2:"White",r2:"White",trim:"White",action:"White",dpad:"White",share:"White",options:"White",ps_btn:"White",stick_l:"Silver",stick_r:"Silver",rings:"Silver",touchpad:"White"}}
  ],
  ps4: [
    {label:"Jet Black",fin:{r:.62},map:{shell_front:"Black",shell_back:"Black",l1:"Slate",r1:"Slate",l2:"Slate",r2:"Slate",action:"Slate",dpad:"Slate",share:"Slate",options:"Slate",ps_btn:"Black",stick_l:"Slate",stick_r:"Slate",touchpad:"Black"}}
  ],
  xbox: [
    {label:"Robot White",fin:{r:.62},map:{shell_front:"Robot White",shell_back:"Robot White",side_shells:"Robot White",bumpers:"Robot White",triggers:"Robot White",action:"White",dpad:"White",view_btn:"Robot White",stick_l:"Robot White",stick_r:"Robot White"}},
    {label:"Carbon Black",fin:{r:.55},map:{shell_front:"Carbon Black",shell_back:"Carbon Black",side_shells:"Carbon Black",bumpers:"Carbon Black",triggers:"Carbon Black",action:"White",dpad:"White",view_btn:"Carbon Black",stick_l:"Carbon Black",stick_r:"Carbon Black"}},
    {label:"Shock Blue",fin:{r:.58},map:{shell_front:"Shock Blue",shell_back:"Robot White",side_shells:"Shock Blue",bumpers:"Carbon Black",triggers:"Carbon Black",action:"White",dpad:"White",view_btn:"Shock Blue",stick_l:"Shock Blue",stick_r:"Shock Blue"}},
    {label:"Pulse Red",fin:{r:.58},map:{shell_front:"Pulse Red",shell_back:"Robot White",side_shells:"Pulse Red",bumpers:"Carbon Black",triggers:"Carbon Black",action:"White",dpad:"White",view_btn:"Pulse Red",stick_l:"Pulse Red",stick_r:"Pulse Red"}},
    {label:"Electric Volt",fin:{r:.58},map:{shell_front:"Electric Volt",shell_back:"Robot White",side_shells:"Electric Volt",bumpers:"Carbon Black",triggers:"Carbon Black",action:"White",dpad:"White",view_btn:"Electric Volt",stick_l:"Electric Volt",stick_r:"Electric Volt"}},
    {label:"Deep Pink",fin:{r:.58},map:{shell_front:"Deep Pink",shell_back:"Robot White",side_shells:"Deep Pink",bumpers:"Carbon Black",triggers:"Carbon Black",action:"White",dpad:"White",view_btn:"Deep Pink",stick_l:"Deep Pink",stick_r:"Deep Pink"}},
    {label:"Velocity Green",fin:{r:.58},map:{shell_front:"Velocity Green",shell_back:"Robot White",side_shells:"Velocity Green",bumpers:"Carbon Black",triggers:"Carbon Black",action:"White",dpad:"White",view_btn:"Velocity Green",stick_l:"Velocity Green",stick_r:"Velocity Green"}},
    {label:"Astral Purple",fin:{r:.58},map:{shell_front:"Astral Purple",shell_back:"Robot White",side_shells:"Astral Purple",bumpers:"Carbon Black",triggers:"Carbon Black",action:"White",dpad:"White",view_btn:"Astral Purple",stick_l:"Astral Purple",stick_r:"Astral Purple"}}
  ]
};
